import React, { useContext } from 'react';
import ListContext from '../ListContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const ListColumnCheckIcon: React.FC<{ 
    checked: boolean, 
    tooltipText: string,
    showUnchecked?: boolean;
}> = ({ 
    checked, 
    tooltipText,
    showUnchecked = false
}) => {
    const { t } = useTranslation();
    const { setListTooltip } = useContext(ListContext);

    // Do not render the check icon
    if (!checked && !showUnchecked) return <></>;

    // Determine the icon and classname
    const icon = checked ? faCheck : faTimes;
    const className = checked ? 'approved-icon' : 'rejected-icon';

    return (
        <div className="check-icon-wrapper"
             onMouseEnter={(e) => {
                // Get the position of the mouse hover element
                const rect = e.currentTarget.getBoundingClientRect();

                // Set the list tooltip position to show on hover
                setListTooltip({
                    x: rect.left - 8,
                    y: rect.top + rect.height / 2,
                    content: (
                        <div>
                            {t(tooltipText)}
                        </div>
                    )
                });
            }}
            onMouseLeave={() => setListTooltip(null)}>
            <div className={className}>
                <FontAwesomeIcon icon={icon} />
            </div>
        </div>
    );
};

export default ListColumnCheckIcon;